import * as React from "react";
const Left = (props) => (
  <svg
    width={5}
    height={8}
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 7.36426L1 4.36426L4 1.36426"
      stroke="white"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default Left;
